<template>
  <div class="bg-[#f4f4f4] h-full px-8">
    <div class="max-w-7xl mx-auto">
      <!-- desktop -->
      <div class="py-10 flex flex-col gap-5">
        <div class="flex items-center justify-center">
          <div class="flex-grow border-t-2 border-[#282828]"></div>
          <h2
            class="px-4 text-[21px] lg:text-3xl text-[#001c54] font-semibold text-center"
          >
            RANKINGS
          </h2>
          <div class="flex-grow border-t-2 border-[#282828]"></div>
        </div>
        <div class="hidden md:block">
          <div
            class="flex flex-col gap-2 lg:flex-row lg:justify-between slick_rank_desktop"
          >
            <div
              class="relative md:min-w-[200px]"
              v-for="rank in ranking"
              :key="rank"
            >
              <div class="w-full">
                <img :src="rank.bgimage" alt="" class="w-[341px] h-[225px]" />
              </div>
              <div class="absolute top-4 left-4 right-7">
                <div class="bg-white max-w-[291px] mx-auto h-[194px]">
                  <div class="flex flex-col gap-2 justify-center items-center">
                    <img
                      :src="rank.innerimage"
                      alt=""
                      srcset=""
                      class="w-[130px] h-[97px]"
                    />
                    <p class="text-[13px] text-[#001c54] px-1">
                      {{ rank.content }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- mobile -->
      <div class="block md:hidden py-5 relative">
        <div class="flex justify-center items-center">
          <!-- carosal prev button -->
          <div
            class="absolute bottom-[46%] right-[-8%] z-10 cursor-pointer bg-[#fccf26] p-2 rounded-full"
          >
            <img
              src="@/assets/MbaFinance/right-arrow.png"
              class="w-[15px] h-[15px] nextRanking"
              width="30px"
              height="40px"
              alt=""
            />
          </div>
          <!-- slick carousal -->
          <div class="slick_rank min-w-[290px]">
            <div class="relative" v-for="rank in ranking" :key="rank">
              <div class="">
                <img :src="rank.bgimage" alt="" class="w-[320px] h-[225px]" />
              </div>
              <div class="absolute top-4 left-4 right-7">
                <div class="bg-white min-w-[220px] mx-auto h-[194px]">
                  <div class="flex flex-col gap-2 justify-center items-center">
                    <img
                      :src="rank.innerimage"
                      alt=""
                      srcset=""
                      class="w-[130px] h-[97px]"
                    />
                    <p class="text-[13px] text-[#001c54] px-1">
                      {{ rank.content }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- carosal next button -->
          <div
            class="absolute bottom-[46%] left-[-9%] z-10 cursor-pointer bg-[#fccf26] p-2 rounded-full"
          >
            <img
              src="@/assets/MbaFinance/left-arrow.png"
              width="30px"
              height="40px"
              class="prevRanking w-[15px] h-[15px]"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import "slick-carousel";
export default {
  name: "CorporaterankingView",
  data() {
    return {
      ranking: [
        {
          id: 1,
          bgimage: require("@/assets/LPnew/images/rank/rank-BG1.png"),
          innerimage: require("@/assets/LPnew/images/rank/rankIcon1.png"),
          content:
            " JAIN (Deemed-to-be University) awarded Graded Autonomy by University Grants Commission (UGC)",
        },
        {
          id: 2,
          bgimage: require("@/assets/LPnew/images/rank/rank-BG2.png"),
          innerimage: require("@/assets/LPnew/images/rank/rankIcon2.png"),
          content:
            " National Assessment and Accredition Council (NAAC) has awarded 'A++' Grade",
        },
        {
          id: 3,
          bgimage: require("@/assets/LPnew/images/rank/rank-BG3.png"),
          innerimage: require("@/assets/LPnew/images/rank/rankIcon3.png"),
          content: "Ranked 91-95 among the top Indian Universities",
        },
        {
          id: 4,
          bgimage: require("@/assets/LPnew/images/rank/rank-BG4.png"),
          innerimage: require("@/assets/LPnew/images/rank/rankIcon4.png"),
          content: " Ranked 68th in the Country",
        },
      ],
    };
  },
  mounted() {
    $(`.slick_rank_desktop`).slick({
      infinite: true,
      autoplay: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,

      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 950,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    });
    $(`.slick_rank`).slick({
      infinite: true,
      autoplay: true,
      prevArrow: $(".prevRanking"),
      nextArrow: $(".nextRanking"),
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,

      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 950,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  },
};
</script>

<style></style>
